import { Component, OnInit } from "@angular/core";
import { Observable, of } from "rxjs";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { AlertifyService } from "../../_models/alertify.service";

import { TemplateService } from "../service/template.service";
import { AppSect, TemplateContent } from "../model/TemplateRulebook";

@Component({
  selector: "app-edit-applicability",
  templateUrl: "./edit-applicability.component.html",
  styleUrls: ["./edit-applicability.component.css"],
  standalone: false,
})
export class EditApplicabilityComponent implements OnInit {
  csskey: string;
  auditName: string;
  appkey: string;
  appSect$: Observable<AppSect[]>;
  selectedRbName: string;
  selectedAppkey: number;
  rulebookList: TemplateContent[];
  currentTopic: string;
  isAnswering: boolean;
  sharePermission: boolean; //

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertifyService,
    public service: TemplateService
  ) {}

  ngOnInit() {
    this.selectedRbName =
      this.service.decodeHtml(this.service.getRbName().value ?? "") ?? "";
    this.isAnswering = false;
    this.service.getCurrent().subscribe((res) => {
      //let item = res.findIndex(x => x.acronym == "Custom"); // Do not display custom question on applicablity page.

      this.rulebookList = res;
    });

    this.auditName = this.service.getAuditName();

    this.route.paramMap.subscribe(
      (paraMap) => (
        (this.csskey = paraMap.get("id")),
        (this.appkey = paraMap.get("appkey")),
        (this.sharePermission = this.service.isTemplateEditable(+this.csskey))
      )
    );
    this.currentTopic = this.service.getTopic(parseInt(this.appkey));
    this.loadApplicability(this.csskey, this.appkey);
  }

  loadApplicability(csskey: string, appkey: string) {
    try {
      this.service.showLoadingAnimation(true);
      this.appSect$ = new Observable<AppSect[]>();
      this.appSect$ = this.service.getApplicability(csskey, appkey);
      let re = /<b>Question:<\/b>/gi;

      this.appSect$.subscribe(
        (res) => {
          this.service.showLoadingAnimation(false);
          res.forEach((element) => {
            element.question = this.service
              .decodeHtml(element.question)
              .replace(re, ""); //decode html entities; remove <b>Question:</b> tag.
            element.exemption = this.service.decodeHtml(element.exemption);
          });
          this.service.revokeReviewFlag(+csskey, +appkey, 1);
        },
        (err) => {
          console.error("got an error:" + err);
          this.service.showLoadingAnimation(false);
          this.alertService.error(err.message);
        },
        () => this.service.showLoadingAnimation(false)
      );
    } catch (Error) {
      this.alertService.error(Error.message);
    }
  }

  onClickRulebook(appkey: number) {
    //console.log("received click event from child: " + appkey);
    this.selectedRbName = this.service.getRbName().value;
    this.appkey = this.service.getKey().value.toString();
    this.currentTopic = this.service.getTopic(parseInt(this.appkey));

    this.loadApplicability(this.csskey, appkey.toString());
  }

  onBackSummary() {
    var myurl = "audithub/apptool/edit/" + this.csskey;
    this.router.navigateByUrl(myurl).then((err) => {
      console.log(err);
    });
  }

  /**
   * Get the mirrored appkey of the rulebook.
   * @param appkey: the appkey of the rulebook.
   * @return: the mirrored appkey if found, otherwise return -1.
   */
  getMirroredAppkey(appkey: number): number {
    if (this.service.isDualLanguageTemplate() === false) return -1;
    for (const acronym of this.rulebookList) {
      for (const topic of acronym.topics) {
        const rb = topic.rulebooks.find((rb) => rb.appKey === appkey);
        if (rb) {
          const mirroredAcronym = this.service.getDualLanguageAcronym(
            acronym.acronym
          );
          if (!mirroredAcronym) return -1;
          const mirroredPub = this.rulebookList.find(
            (a) =>
              a.acronym === mirroredAcronym &&
              a.releaseNum === acronym.releaseNum
          );
          if (!mirroredPub) return -1;
          const mirroredTopic = mirroredPub.topics.find(
            (t) => t.topic === topic.topic
          );
          if (!mirroredTopic || !mirroredTopic.rulebooks.length) return -1;
          return mirroredTopic.rulebooks[0].appKey;
        }
      }
    }
    return -1;
  }

  /**
   * Answer the applicability questions.
   * @param answer
   */
  onAnswerApp(answer: string) {
    this.updateAppAnser(
      this.csskey,
      this.appkey ? parseInt(this.appkey) : 0,
      answer
    );
    let mirroredAppkey = this.getMirroredAppkey(
      this.appkey ? parseInt(this.appkey) : 0
    );
    if (mirroredAppkey !== -1) {
      this.updateAppAnser(this.csskey, mirroredAppkey, answer);
    }
  }

  updateAppAnser(csskey: string, appkey: number, answer: string) {
    this.service.showLoadingAnimation(true);
    this.service.updateAppAnswer(csskey, appkey, answer).subscribe(
      (val) => {
        this.isAnswering = false;
        this.selectedRbName = this.selectedRbName + "";
        const rb = this.rulebookList
          .flatMap((arcon) => arcon.topics)
          .flatMap((tp) => tp.rulebooks)
          .find((rb) => rb.appKey == val.appkey);

        if (rb) {
          rb.percentage = this.service.calRulebookPercentage(answer);
          rb.checkNa = this.service.calCheckNa(answer);
          rb.appAnswer = answer;
        }
        // Update the cache
        this.service.cacheRulebookLocalStorage(
          parseInt(this.csskey),
          this.rulebookList
        );
      },
      (error) => {
        console.error("updateAppAnser() return: " + error.error);
      },
      () => {
        this.service.showLoadingAnimation(false);
      }
    );
  }
}
